import React from 'react';
import styled from 'styled-components';
import EventHeader from '@features/eventDetail/components/EventHeader';
import EventSubscription from '@features/eventDetail/components/EventSubscription';
import EventContentWithSidePanel from '@features/eventDetail/components/EventContentWithSidePanel';
import Loader from '@features/ui/components/Loader';
import FormikContextProvider from '@features/serieDetail/components/FormikContextProvider';

const EventSubscriptionTemplate = ({ isLoading } : { isLoading: boolean }) => (
  isLoading ? <StyledLoader /> : (
    <>
      <EventHeader />
      <EventContentWithSidePanel hideSubscribeButton>
        <FormikContextProvider><EventSubscription /></FormikContextProvider>
      </EventContentWithSidePanel>
    </>
  )
);

export default EventSubscriptionTemplate;

const StyledLoader = styled(Loader)`
  width: 100%;
`;
